<template>
  <spinner v-if="loading"></spinner>
  <template v-else>
    <section class="wishlist-list" v-if="!showSingleWishlist">
      <h1>Mine ønskelister</h1>
      <div>{{ wishlistCountText }}</div>
      <div class="wishlist-wrapper">
        <button class="btn wishlist add" @click="openAddWishlistModal">
          <span class="fs-1">+</span>
          <span>Opret ny ønskeliste</span>
        </button>
        <button
          class="btn wishlist"
          v-for="(wishlist, index) in wishlists"
          :key="index"
          @click="openWishlist(wishlist.id)"
        >
          <span
            :style="[
              wishlist.image
                ? {
                    backgroundImage: 'url(' + wishlist.image + ')',
                    color: '#fff',
                  }
                : '',
            ]"
          ></span>
          <span>{{ wishlist.name }} ({{ wishlist.documents.length }})</span>
        </button>
      </div>
      <add-wishlist-modal v-if="showAddWishlistModal" />
    </section>
    <single-wishlist :wishlistId="singleWishlistId" v-if="showSingleWishlist" />
  </template>
  <div role="alert" :class="[{ show: showAppInfo }, 'favorite-info-box']">
    {{ appInfo }}
  </div>
</template>
<script>
import Spinner from "./components/Spinner.vue";
import AddWishlistModal from "./components/Modals/AddWishlistModal.vue";
import SingleWishlist from "./components/SingleWishlist.vue";
export default {
  name: "ProfileFavoritesApp",
  components: {
    Spinner,
    AddWishlistModal,
    SingleWishlist,
  },
  data() {
    return {
      loading: true,
      showAddWishlistModal: false,
      showSingleWishlist: false,
      singleWishlistId: 0,
      showAppInfo: false,
      appInfo: "",
    };
  },
  computed: {
    wishlists() {
      return this.$store.state.wishlists;
    },
    wishlistCountText() {
      if (typeof this.$store.state.wishlists !== "undefined" && this.$store.state.wishlists.length) {
        return this.$store.state.wishlists.length > 1
          ? "Du har gemt " + this.$store.state.wishlists.length + " ønskelister"
          : "Du har gemt 1 ønskeliste";
      }
      return "Du har ikke nogen gemte ønskelister";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      const params = new Proxy(new URLSearchParams(decodeURI(window.location.hash.split("?")[1])), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      if (params.listid) {
        this.showWishlist(params.listid);
      }
      this.$store.dispatch("getPageUrls");
      this.loading = false;
    },
    openWishlist: function(id) {
      window.location.href = window.location.href.split('#')[0] + '#?listid=' + id;
      this.showWishlist(id);
    },
    showWishlist: function (id) {
      this.singleWishlistId = id;
      this.showSingleWishlist = true;
    },
    closeSingleList: function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.showSingleWishlist = false;
    },
    openAddWishlistModal: function () {
      this.showAddWishlistModal = true;
    },
    closeAddWishlistModal: function () {
      this.showAddWishlistModal = false;
    },
    wishlistDeleted: function (wishlistName) {
      this.closeSingleList();
      this.appInfo = wishlistName + " er slettet";
      this.showAppInfo = true;
      setTimeout(() => {
        this.showAppInfo = false;
        this.appInfo = "";
      }, 3000);
    }
  },
};
</script>